module.exports = __webpack_public_path__ + "01c0aac935d7206c008c803d63fa2fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/screenshot.jpg
// module id = 174
// module chunks = 0